/* eslint-disable react-hooks/exhaustive-deps */
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import ITRFilingApi from "../../api/ITRFilingApi";
import { AppAuthRoles } from "../../config/app-constants";
import {
	TrackAdminFilingsStatus,
	TrackCAFilingsStatus,
	TrackEFilingStatus
} from "../../config/filingConstants";
import { EActionItem, EToastvariant } from "../../config/interfaces";
import { useAppDispatch, useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";
import { loggedInUserSelector } from "../../redux/slice/LoggedInUserSlice";
import { showToastMsg } from "../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../services";
import { SelectInputField } from "../fields";
import { ConfirmationModal } from "../modals";

type Props = {};

const TrackFilingStatus: React.FC<Props> = (props: Props) => {
	const {} = props;
	const { filingUUID } = useParams();

	const dispatch = useAppDispatch();
	const { loggedInUser } = useAppSelector(loggedInUserSelector);
	const { currentFilingData } = useAppSelector(ITRFilingSelector);

	const [trackingStatus, setTrackingStatus] = useState<string>(currentFilingData?.status || "");
	const [showConfirmationModal, setShowConfirmationModal] = useState<string>("");
	const [selectOptions, setSelectedOptions] = useState<any[]>([]);
	const [isPerformingAction, setIsPerformingAction] = useState<EActionItem>(EActionItem.NULL);

	useEffect(() => {
		if (loggedInUser?.role === AppAuthRoles.ADMIN) {
			setSelectedOptions(() => UtilService.convertToArray(TrackAdminFilingsStatus));
		} else if (
			loggedInUser?.role !== AppAuthRoles.ADMIN &&
			loggedInUser?.uuid !== currentFilingData?.userUuid
		) {
			setSelectedOptions(() => UtilService.convertToArray(TrackCAFilingsStatus));
		}
	}, [filingUUID]);

	const handleEFilingStatus = async () => {
		try {
			if (!showConfirmationModal) {
				return;
			}

			setTrackingStatus(() => showConfirmationModal);
			setIsPerformingAction(() => EActionItem.CREATE);
			const authApi = ITRFilingApi.getInstance();
			const _data = { status: showConfirmationModal };
			await authApi.setEfilingStatus(_data, filingUUID);

			dispatch(
				showToastMsg({
					isVisible: true,
					title: "Success",
					message: "Filing status updated successfully",
					variant: EToastvariant.Success
				})
			);
		} catch (error) {
			setTrackingStatus(() => currentFilingData?.status || "");
			dispatch(
				showToastMsg({
					isVisible: true,
					title: "Error",
					message: UtilService.getErrorMessage(error),
					variant: EToastvariant.Danger
				})
			);
		} finally {
			setShowConfirmationModal(() => "");
			setIsPerformingAction(() => EActionItem.NULL);
		}
	};

	return (
		<>
			{/* Admin and Expert can update tracking status */}
			{loggedInUser?.role === AppAuthRoles.ADMIN ||
			(loggedInUser?.role !== AppAuthRoles.ADMIN &&
				loggedInUser?.uuid !== currentFilingData?.userUuid) ? (
				<div className="status-field-form">
					<SelectInputField
						formType="GENERAL"
						placeholder="Select Status"
						name="status"
						isSearchable={true}
						isOptionArrayOfObject={true}
						options={selectOptions}
						value={{
							"label": TrackEFilingStatus[trackingStatus]?.label || "",
							"value": trackingStatus
						}}
						onChange={(selectedOption) => {
							if (trackingStatus === selectedOption?.value) {
								return;
							} else {
								setShowConfirmationModal(selectedOption?.value);
							}
						}}
						onBlur={() => null}
					/>
				</div>
			) : null}

			<ConfirmationModal
				showModal={!!showConfirmationModal}
				iconColorClass="text-danger"
				title="Are you sure?"
				message={
					<p>
						You want to change the filing status to&nbsp;
						{TrackEFilingStatus[showConfirmationModal]?.label}.
					</p>
				}
				onYesBtnClick={() => handleEFilingStatus()}
				onNoBtnClick={() => setShowConfirmationModal(() => "")}
				onYesBtnText="Change"
				icon={faTrashAlt}
				isProcessing={isPerformingAction === EActionItem.CREATE}
			/>
		</>
	);
};

export default TrackFilingStatus;
